/**
 * The store's old page URLs (profile plan items 92 and 93, decision 31):
 * the store lives on the one Profile page now and its documents on Store
 * Documents, so a bookmark or a banner link to the store page lands on
 * the documents page when its `?tab=` names one of the document tabs,
 * and on Profile otherwise, the search kept either way.
 */
import { Navigate, useLocation } from 'react-router'
import { PATHS } from '@/navigation/paths'
import { isStoreDocumentTab } from '@/navigation/storeDocumentTabs'

const StoreProfileRedirect = () => {
  const { search } = useLocation()
  const tab = new URLSearchParams(search).get('tab')
  const target = isStoreDocumentTab(tab) ? PATHS.dashboard.store.documents : PATHS.dashboard.profile
  return <Navigate to={`${target}${search}`} replace />
}

export default StoreProfileRedirect
